export * from './architectDetails';

export type IAccordianDetails = {
	id: number;
	name: string | null;
	number: string | null;
	isActive: boolean;
};

export const defaultAccordianDetails = [{ id: 0, isActive: false, name: '', number: '' }];

export const defaultArchitectDetailFormInitialValues: IArchitectDetailIntialValue = {
	architect_details: defaultAccordianDetails,
};

export interface IArchitectDetailIntialValue {
	architect_details: IAccordianDetails[];
}
